import styled from 'styled-components';

import { NumberInput } from 'components/number-input';
import { TextareaInput } from 'components/textarea-input';

export const Spacing = styled.div<{ x?: number; y?: number }>`
  padding: ${({ y = 0 }) => (y === 0 ? 0 : `${y}rem`)} ${({ x = 0 }) => (x === 0 ? 0 : `${x}rem`)};
`;

export const CenteredP = styled.p`
  font-size: 0.875rem;
  text-align: center;
`;

export const CommentTextareaInput = styled(TextareaInput)`
  height: 6.5rem;
  font-family: ${Styles.fontFamily.body};
`;

export const ItemNameText = styled.span`
  font-size: 0.875rem;
  font-weight: ${Styles.fontWeight.heavy};
`;

export const LeftMiddleFlex = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  label {
    margin: 0;
  }
`;

export const MissingItemNumberInput = styled(NumberInput)`
  margin: 0 1rem 0 0.5rem;
`;
